import { useContext } from "react";
import { ReturnRequestsFiltersContext } from "./return-requests-filters.provider";

export function useReturnRequestsFilters() {
  const context = useContext(ReturnRequestsFiltersContext);

  if (!context) {
    throw new Error(
      "useReturnRequestsFilters must be used within a ReturnRequestsFiltersProvider",
    );
  }

  return context;
}
